import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { Notification } from '../_models/notification.model';

@Injectable()
export class NotificationService {
  constructor(private http: HttpClient) {}

  getNotifications(): Observable<Notification[]> {
    let httpHeaders = new HttpHeaders();
    httpHeaders = httpHeaders.append('no_token_refresh', 'true');
    return this.http.get<Notification[]>('api/notifications/', {
      headers: httpHeaders,
    });
  }

  clearNotifications() {
    return this.http.get<any>('api/notifications/clear/');
  }

  deleteNotification(notId: number) {
    const url = `${'api/notifications'}/${notId}`;
    return this.http.delete(url);
  }

  addNotification(an: Notification): Observable<Notification> {
    const httpHeaders = new HttpHeaders();
    httpHeaders.set('Content-Type', 'application/json');
    return this.http.post<Notification>('api/notifications/', an, {
      headers: httpHeaders,
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private handleError<T>(operation = 'operation', result?: any) {
    return (error: any): Observable<any> => {
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // Let the app keep running by returning an empty result.
      return of(result);
    };
  }
}
